import { Alert, Stack } from '@mui/material'
import React from 'react'
import PlayerTable from './PlayerTable'
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer';
import { Info, InfoOutlined } from '@mui/icons-material';

const AvailablePlayers = () => {
  const { lineups, selectedLineupId, selectedMatchups } = useSelector((state: IRootState) => state.lineupBuilder);
  const lineup = lineups?.find(x => x.id === selectedLineupId);

  const getMatchupsText = () => {
    if (selectedMatchups.length === 0) {
      return 'All matchups'
    } if (selectedMatchups.length === 2) {
      return `${selectedMatchups[0]} @ ${selectedMatchups[1]}`
    } else {
      return `${selectedMatchups.length / 2} Games`

    }
  }
  return (
    <Stack bgcolor='#101010' borderRadius='10px' fontFamily='Inter' position='relative' height='100%'>
      {
        lineup?.simStatus === 'loading' ? (
          <Stack zIndex={10000} justifyContent='center' alignItems='center' position='absolute' height='100%' width="100%" bgcolor='#1C1C1C' borderRadius='10px'>
            <Stack height='200px' sx={{
              '& img': {
                height: '100%',
                width: '100%',
              }
            }}>
              <img src={`${process.env.PUBLIC_URL}/images/Loadinganimation.gif`} alt="loading" />
            </Stack>
          </Stack>
        ) : (
          <>
            <Stack padding='16px' direction='row' alignItems='center' columnGap='15px'>
              <Stack fontSize='24px' fontWeight={700}>Available Players</Stack>
              <Stack fontSize='18px' fontWeight={400}>{getMatchupsText()}</Stack>
              <Alert severity="info" variant='outlined' icon={<InfoOutlined sx={{ color: '#1D9588'}}/>} sx={{ color: '#1D9588', borderColor: '#1D9588', whiteSpace: 'nowrap', display: { xs: 'none', lg: 'flex', xl: 'none'}}}>Zoom out to view more rows</Alert>
            </Stack>
            <PlayerTable />
          </>
        )
      }
    </Stack>
  )
}

export default AvailablePlayers